export default "__VITE_ASSET__DgkbiniB__"